import MondialRelayAdapter from './mondial-relay/mondial-relay.adapter'

export class AdapterFactory {
  static create(code: string) {
    switch (code) {
      case 'mondial-relay': {
        return new MondialRelayAdapter(code)
      }
    }
  }
}
